import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfiguration } from '../../core/models/app-configuration.model';
import { Observable } from 'rxjs';
import { VerifySerialRequest } from '../model/serial-number.model';
import { TwoFADevice } from 'app/pages/security/twostepverification/model/device.model';
import { EnableOtpDisplayRequest } from '../model/enable-otp.model';
import { TwoFactorPairingResponse, TwoFactorPairingStatus } from 'app/pages/security/twostepverification/model/pairing.model';
import * as moment from 'moment'; // NOSONAR: This import is necessary for moment usage. Default import doesn't work.
import { OtpDisplayRequest, OtpDisplayResponse } from '../model/otp-display.model';

/**
 * Otp Display Service
 * @description Angular service used otp display service service
 */
@Injectable({ providedIn: 'root' })
export class OtpDisplayService {
  constructor(private readonly http: HttpClient, private readonly appConfig: AppConfiguration) { }

  getResourceUrl(): string {
    return this.appConfig.serverApiUrl + '/api/v1/twofactor/otpdisplay';
  }

  enableOtpDisplay(req: EnableOtpDisplayRequest, _authReqId: string): Observable<{ enabled: boolean }> {
    return this.http.post<{ enabled: boolean }>(this.getResourceUrl() + '/pairing', req);
  }

  getOtpDisplayAvailable(): Observable<{ data: boolean }> {
    return this.http.get<{ data: boolean }>(this.getResourceUrl() + '/available', {});
  }

  getOtpDisplaySupplier(): Observable<{ resellerBusinessName: string }> {
    return this.http.get<{ resellerBusinessName: string }>(this.getResourceUrl() + '/supplierInfo', {});
  }

  disableOtpDisplay(req: EnableOtpDisplayRequest): Observable<{ enabled: boolean }> {
    if (req.otp !== null && req.otp !== '') {
      return this.http.put<{ enabled: boolean }>(this.getResourceUrl() + '/unpairing/verifiedmobile', req);
    } else {
      return this.http.put<{ enabled: boolean }>(this.getResourceUrl() + '/unpairing/notverifiedmobile', req);
    }
  }

  /**
   * Utility function for convert date in string format to a Moment date for a specific field
   * @param res server response
   * @param key field to convert
   */
  protected convertDateFromServer(res: TwoFactorPairingResponse | TwoFADevice | TwoFactorPairingStatus, key: string) {
    if (res) {
      // @ts-ignore
      res[key] = res[key] ? moment(res[key]) : undefined;
    }
    return res;
  }

  verifySerialNumber(req: VerifySerialRequest): Observable<void> {
    return this.http.post<void>(this.getResourceUrl() + '/serialverification', req);
  }

  verifyOtpDisplay(req: OtpDisplayRequest): Observable<OtpDisplayResponse> {
    return this.http.post<OtpDisplayResponse>(this.getResourceUrl() + '/verification', req);
  }
}
